import React from 'react';
import TooltipIcon from '~/components/TooltipIcon/TooltipIcon';

const statusIcons = new Map();
// prettier-ignore
for(
    const [ key, type, message, iconClass ]
    of [
        ['success','check','Success', ''],
        ['error','cross','Error', ''],
        ['warning','warning','Warning', ''],
        ['Enabled','checkmark-circle','Enabled', 'icon-status-enabled'],
        ['Disabled','blacklist','Disabled', 'icon-status-disabled']
    ]
){
    statusIcons.set(
        key,
        <TooltipIcon
            type={type}
            message={message}
            className={`ag-status-icon status-icon ${iconClass}`}
        />
    );
}

export const iconStatusCellRender = params => {
    const key = params.node?.data?.status;
    const icon = statusIcons.get(key);

    if (!icon) {
        return '';
    }

    // Opt-in left margin for specific columns via cellRendererParams
    // Usage: cellRendererParams: { addLeftMargin: true }
    if (params.colDef?.cellRendererParams?.addLeftMargin) {
        return <span className="mui-ms-1">{icon}</span>;
    }

    return icon;
};
